export const NY_MARBLE_PHONE_NUMBER = "+19179702725";
export const NJ_MARBLE_PHONE_NUMBER = "+17323297676";
export const OH_MARBLE_PHONE_NUMBER = "+16144085572";
export const AZ_MARBLE_PHONE_NUMBER = "+19285175787";
export const MARBLE_MESSAGING_NUMBER_DEPRECATED = "+16893199432";
